import script from "./PriceBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceBlock.vue?vue&type=script&setup=true&lang=js"

import "./PriceBlock.vue?vue&type=style&index=0&id=4ec9cb41&lang=scss"

const __exports__ = script;

export default __exports__